export default __webpack_public_path__ + "static/media/trello.637a76b5.svg";